export default __webpack_public_path__ + "static/media/card.e5e03922.svg";